import { LogoMark } from "./Logo";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 bg-[#0B1120]/70"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="col-span-2">
            <div className="flex items-center gap-3">
              <LogoMark size={40} />
              <span className="font-display text-lg font-semibold tracking-tight">
                Be<span className="text-[#00FAF8]">Parent</span>
              </span>
            </div>
            <p className="mt-6 max-w-md text-white/50 text-[15px] leading-relaxed">
              Eltern sein. Eltern bleiben. Strukturierte Dokumentation für
              familienrechtliche Verfahren — verschlüsselt, offline, neutral.
            </p>
          </div>

          {/* Produkt */}
          <div>
            <div className="font-mono-bp text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">
              Produkt
            </div>
            <ul className="space-y-3">
              {[
                ["Was ist BeParent", "/#produkt"],
                ["Datenschutz", "/#datenschutz"],
                ["Musteranalyse", "/#musteranalyse"],
                ["PDF-Export", "/#pdf-export"],
              ].map(([l, h]) => (
                <li key={l}>
                  <a
                    href={h}
                    className="text-white/70 text-sm hover:text-[#00FAF8] transition-colors"
                    data-testid={`footer-link-${l.replace(/\s/g, "-").toLowerCase()}`}
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div>
            <div className="font-mono-bp text-[10px] uppercase tracking-[0.3em] text-white/40 mb-4">
              Unternehmen
            </div>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/ratgeber"
                  className="text-white/70 text-sm hover:text-[#00FAF8] transition-colors"
                >
                  Ratgeber
                </Link>
              </li>
              <li>
                <Link
                  to="/kontakt"
                  data-testid="footer-link-kontakt"
                  className="text-white/70 text-sm hover:text-[#00FAF8] transition-colors"
                >
                  Kontakt
                </Link>
              </li>
              <li>
                <Link
                  to="/impressum"
                  data-testid="footer-link-impressum"
                  className="text-white/70 text-sm hover:text-[#00FAF8] transition-colors"
                >
                  Impressum
                </Link>
              </li>
              <li>
                <a
                  href="/#datenschutz"
                  className="text-white/70 text-sm hover:text-[#00FAF8] transition-colors"
                >
                  Datenschutz
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs font-mono-bp text-white/40">
            © {new Date().getFullYear()} BeParent · Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-xs font-mono-bp text-white/40">
              Ruhiger Fokus. Keine Cloud.
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-[#00FAF8]/30 bg-[#00FAF8]/5 px-3 py-1.5">
              <span className="cyan-dot" />
              <span className="text-[11px] font-mono-bp text-[#00FAF8]">
                Offline First
              </span>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
